//home-api.js

import axios from 'axios'
import { API_URL } from '@/config/api.config'

const homeAPI = {
    /**
     * 获取Banner列表
     */
    getBannerList: async () => {
        try {
            const response = await axios.get(`${API_URL}/banner`);
            return response.data;
        } catch (error) {
            console.error('获取Banner列表失败:', error);
            throw error;
        }
    },



    /**
     * 批量更新Banner
     */
    batchUpdateBanner: async (formData) => {
        try {
            const response = await axios.put(`${API_URL}/banner/batch`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('批量更新Banner失败:', error);
            throw error;
        }
    },



    /**
     * Banner跳转链接选项
     */
    getbannerLink: async () => {
        try {
            const response = await axios.get(`${API_URL}/banner/link`);
            return response.data;
        } catch (error) {
            console.error('获取Banner跳转链接选项失败:', error);
            throw error;
        }
    },

    /**
     * 获取快捷入口列表
     */
    getQuickEntryList: async () => {
        try {
            const response = await axios.get(`${API_URL}/quick-entry`);
            return response.data;
        } catch (error) {
            console.error('获取快捷入口列表失败:', error);
            throw error;
        }
    },

    /**
     * 批量更新快捷入口
     */
    batchUpdateQuickEntry: async (formData) => {
        try {
            const response = await axios.put(`${API_URL}/quick-entry/batch`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('批量更新快捷入口失败:', error);
            throw error;
        }
    },

    /**
     * 快捷入口跳转链接选项
     */
    getQuickEntryLink: async () => {
        try {
            const response = await axios.get(`${API_URL}/quick-entry/link`);
            return response.data;
        } catch (error) {
            console.error('获取快捷入口跳转链接选项失败:', error);
            throw error;
        }
    },
    
    /**
     * 获取首页更新时间
     */
    getHomeUpdateTime: async () => {
        try {
            const response = await axios.get(`${API_URL}/home/updatetime`);
            return response.data;
        } catch (error) {
            console.error('获取首页更新时间失败:', error);
            throw error;
        }
    },
};
export default homeAPI;